import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 3.6rem;
  display: flex;
  align-items: center;
  justify-content: center;

  .chevron-icon {
    position: absolute;
    cursor: pointer;

    transition: 0.3s;
    filter: grayscale(0);
  }

  .chevron-icon:hover {
    opacity: 0.8;
  }

  .chevron-icon.up {
    top: -2rem;
  }

  .chevron-icon.down {
    bottom: -2rem;
  }

  .left-carousel {
    overflow: hidden;
    height: 100%;
    max-height: 25rem;
  }

  .left-carousel #scroller {
    display: flex;
    align-items: center;
    gap: 1.6rem;
    flex-direction: column;
    transition: 0.3s transform;
  }

  .left-carousel .image-carousel {
    cursor: pointer;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.4rem;
    border: 1px solid var(--gray_light);
    transition: 0.3s;
  }

  .left-carousel .image-carousel:hover {
    border-color: var(--gray_medium);
    transition: 0.15s;
  }

  .left-carousel .image-carousel.active {
    border-color: var(--gray_medium);
  }

  @media (max-width: 768px) {
    &.have-correlatos {
      display: none;
    }

    .left-carousel {
      max-height: 17rem;
    }

    .icon.arrow-up-icon {
      top: -1.2rem;
    }

    .icon.arrow-down-icon {
      bottom: -1.2rem;
    }
  }

  @media (max-width: 520px) {
    max-height: 11rem;

    #scroller {
      gap: 1rem;
    }

    .image-carousel {
      width: 80%;
    }
  }

  @media (max-width: 400px) {
    .left-carousel {
      max-height: 7rem;
    }
  }
`;
